<template>
  <div class="time-picker">
    <fieldset class="time-picker--input">
      <v-text-field
        dense
        solo
        flat
        full-width
        height="48"
        v-model="displayTime"
        label="Please use format hh:mm"
        :rules="[timeRule]"
        :disabled="readonly"
        @blur="formatTime"
        @input="validateInput"
        @keydown="validateInput"
        @keyup="validateInput"
        @change="formatTime"
      />
    </fieldset>
    <v-select
      solo
      flat
      dense
      full-width
      hide-details
      height="48"
      :items="['AM', 'PM']"
      :disabled="readonly"
      v-model="period"
      label="Select AM/PM"
      class="time-picker--period"
      @change="formatTime"
    ></v-select>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: 'time',
    },
    initialTime: {
      type: String,
      default: '06:00 AM',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    isSubmit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      time: '', // Internal 24-hour time
      period: 'AM',
      displayTime: '06:00 AM',
      timeRule: value => {
        const regex = /^([0-1]?[0-9]|2[0-3]):([0-5][0-9]) (AM|PM)$/
        if (regex.test(value)) {
          return true
        } else {
          return false
        }
      },
    }
  },
  mounted() {
    const [hour, minute] = this.initialTime.split(':')
    if (hour >= '12') this.period = 'PM'
    else this.period = 'AM'
    const formatedTime = `${hour}:${minute} ${this.period}`
    this.displayTime = formatedTime
  },
  methods: {
    validateInput() {
      // This function now just needs to ensure the rule is triggered
      this.displayTime = this.displayTime.replace(';', ':')
      this.timeRule(this.displayTime)
    },
    formatTime() {
      let [hour, minute] = this.displayTime.split(':')
      if (hour && minute) {
        hour = parseInt(hour, 10)
        minute = parseInt(minute, 10)
        let seconds = 0

        // Round minutes to the nearest 15
        minute = Math.round(minute / 15) * 15
        if (minute === 60) {
          minute = 0
          hour++
        }

        // Adjust hour based on period and rounding
        if (hour === 12) {
          hour = this.period === 'AM' ? 0 : 12 // Corrects hour when exactly on the hour change
        } else if (this.period === 'PM' && hour < 12) {
          hour += 12
        } else if (this.period === 'AM' && hour >= 12) {
          hour -= 12
        }

        // Update the internal time state
        this.time =
          seconds !== 0
            ? `${hour.toString().padStart(2, '0')}:${minute
                .toString()
                .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
            : `${hour.toString().padStart(2, '0')}:${minute
                .toString()
                .padStart(2, '0')}`
        this.displayTime = `${
          hour % 12 === 0 ? 12 : hour % 12
        }:${minute.toString().padStart(2, '0')} ${this.period}`

        this.$emit('input', {
          name: this.name,
          value: `${this.time}`,
        })
      }
    },
  },
  watch: {
    period() {
      this.formatTime()
    },
    initialTime: {
      handler(newVal) {
        if (newVal) {
          const [hour, minute] = newVal.split(':')
          if (hour >= '12') this.period = 'PM'
          else this.period = 'AM'
          const formatedTime = `${hour}:${minute} ${this.period}`
          this.displayTime = formatedTime
        }
      },
      immediate: true,
    },
    isSubmit(val) {
      if (val) {
        this.period = 'AM'
        this.displayTime = '06:00 AM'
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.time-picker {
  display: flex;
  align-items: flex-start;
  gap: 10px;

  &--input {
    display: flex;
    flex-direction: column;
    width: 200px;
    border: none;
  }

  &--period {
    max-width: 100px;
  }
}

.error-message {
  color: $bh-red;
  font-size: 12px;
}
</style>
